import { Component, Input } from '@angular/core';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { SettingService } from 'src/common/services/setting/setting.service';


@Component({
  selector: 'sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss']
})
export class SignComponent {

  GLOBAL = new GlobalConstants();

  @Input()
  action: any;

  @Input()
  moduleType: string;

  constructor(
    private setting: SettingService
  ) {
  }

 getSignTitle(): string {
    const done = this.action?.done;
    const accepted = !!this.action?.accepted;
    const canceled = !!this.action?.canceled;

    return `${!done ? 'Pending ' : ''}${this.setting.getParamValueName('actionTypes', this.action.type)} ${done ? (accepted ? ' Signed' : ' Not Signed') : ''}${canceled ? ' & Canceled' : ''}`;
  }


}
